import { useNavigate } from 'react-router-dom';

const ProfileCompletionModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleOkClick = () => {
    onClose();
    navigate('/airliner/profile');
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 w-96 shadow-lg">
        {/* Close Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-full border-2 border-red-400 flex items-center justify-center">
            <svg
              className="w-8 h-8 text-red-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-center text-lg font-semibold text-gray-800 mb-2">
          You have not completed your profile
        </h2>

        {/* Description */}
        <p className="text-center text-sm text-gray-600 mb-6">
          Please complete your profile before adding an aircraft
        </p>

        {/* OK Button */}
        <div className="flex justify-center">
          <button
            onClick={handleOkClick}
            className="bg-yellow-400 hover:bg-yellow-500 text-gray-800 font-semibold py-2 px-8 rounded transition-colors duration-200"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileCompletionModal;
